import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { principles } from '../../data/about';
export function PrinciplesSection() {
  return <Section tone="surface" bordered labelledBy="principles-title" data-id="element-56" data-mp="1rfx19pjwgfzp">
      <Container data-id="element-57" data-mp="1mgk9cqe68iq9">
        <Reveal data-id="element-58" data-mp="1mg0who3dokj3">
          <h2 id="principles-title" className="max-w-[18ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-59" data-mp="1mfix4ilf5q6y">
            What we believe, stated plainly.
          </h2>
          <p className="mt-6 max-w-[52ch] text-body text-muted" data-id="element-60" data-mp="1vgyvfryym1ut">
            Six positions we hold. They decide what we take on, how we work and what we will argue
            with you about.
          </p>
        </Reveal>

        <ol className="mt-14 border-t border-hairline lg:mt-16" data-id="element-61" data-mp="2j6t4rzk2l8ab">
          {principles.map((principle, index) => <Reveal as="li" key={principle.title} delay={index * 0.05} data-id="element-62" data-mp="2f5hkm9jytf9i" data-mpi={index}>
              <div className="grid gap-3 border-b border-hairline py-8 md:grid-cols-12 md:gap-8" data-id="element-63" data-mp="2f3emt3ckmhu8">
                <p className="text-small tabular-nums text-muted md:col-span-1" data-id="element-64" data-mp="23damkewyrxiw">
                  {String(index + 1).padStart(2, '0')}
                </p>
                <h3 className="max-w-[20ch] text-[24px] leading-[1.25] tracking-[-0.025em] text-ink md:col-span-5 lg:text-[28px]" data-id="element-65" data-mp="2cauqjvm7o7x7">
                  {principle.title}
                </h3>
                <p className="max-w-[46ch] text-body text-muted md:col-span-6" data-id="element-66" data-mp="2malipqnauau4">
                  {principle.description}
                </p>
              </div>
            </Reveal>)}
        </ol>
      </Container>
    </Section>;
}